import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { InsulinAdministrationContent } from "@madmedical/ui";
import { useMe, usePatient } from "@madmedical/user";
import { UnderlyingCondition } from "@madmedical/medical";
import InsulinProviders from "./InsulinProviders";
import DeleteInsulinAdministrationModal from "./DeleteInsulinAdministrationModal";
import EditInsulinAdministrationModalForm from "./EditInsulinAdministrationModalForm";
export const InsulinAdministrationPage = () => {
    var _a, _b;
    const { roles: { isPatient }, } = useMe();
    const { patient } = usePatient();
    const [editAdministrationData, setEditAdministrationData] = useState();
    const [deleteAdministrationId, setDeleteAdministrationId] = useState();
    const handleDeletePress = useCallback((id) => {
        setDeleteAdministrationId(id);
    }, []);
    const handleDialogClose = useCallback(() => {
        setDeleteAdministrationId(undefined);
    }, []);
    const insulinUser = ((_a = patient === null || patient === void 0 ? void 0 : patient.underlyingConditions) === null || _a === void 0 ? void 0 : _a.includes(UnderlyingCondition.Insulin)) &&
        ((_b = patient === null || patient === void 0 ? void 0 : patient.packages) === null || _b === void 0 ? void 0 : _b.some((p) => p.type === "diabetes"));
    return (_jsxs(InsulinProviders, { children: [_jsx(InsulinAdministrationContent, { isPatient: isPatient, patientName: patient === null || patient === void 0 ? void 0 : patient.fullName, deleteAdministration: handleDeletePress, editAdministration: setEditAdministrationData, insulinUser: insulinUser }), _jsx(DeleteInsulinAdministrationModal, { id: deleteAdministrationId, open: !!deleteAdministrationId, onClose: handleDialogClose }), _jsx(EditInsulinAdministrationModalForm, { open: !!editAdministrationData, onClose: () => setEditAdministrationData(undefined), administrationData: editAdministrationData })] }));
};
